import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translation_de from "./resources/de-de";
import translation_en from "./resources/en-us";
import translation_es from "./resources/es-es";
import translation_fr from "./resources/fr-fr";
import translation_it from "./resources/it-it";
import translation_pl from "./resources/pl-pl";
import translation_sr_cyrl from "./resources/sr-cyrl";
import translation_sr_latn from "./resources/sr-latn";

export interface IResource {

    feedback_button_text: string;
    feedback_cta_0_3: string;
    feedback_cta_4_6: string;
    feedback_cta_7_8: string;
    feedback_cta_9_10: string;
    feedback_mail_subject: string;
    feedback_text_legend: string;
    feedback_text_title: string;
    feedback_title_finished: string;
    feedback_title_ongoing: string;
    feedback_title_question: string;
    feedback_value_worst: string;
    feedback_value_best: string;

    onboarding_title: string;
    onboarding_description_one: string;
    onboarding_description_two: string;
    onboarding_description_three: string;
    onboarding_description_four: string;
    onboarding_label_firstName: string;
    onboarding_label_lastName: string;
    onboarding_label_theme: string;
    onboarding_label_lightTheme: string;
    onboarding_label_darkTheme: string;
    onboarding_label_color: string;
    onboarding_label_green: string;
    onboarding_label_indigo: string;
    onboarding_label_pink: string;
    onboarding_label_teal: string;
    onboarding_label_yellow: string;
    onboarding_label_orange: string;
    onboarding_label_purple: string;
    onboarding_label_consentAgree: string;
    onboarding_label_consentTermsOfUse: string;
    onboarding_label_consentAnd: string;
    onboarding_label_consentPrivacy: string;
    onboarding_button_jointext: string;

    invite_title_text: string;
    invite_legend_text: string;
    invite_link_label: string;
    invite_link_defaultCopied: string;
    invite_link_email: string;
    invite_link_sms: string;
    invite_link_copy: string;
    invite_mail_subject: string;
    invite_mail_body: string;
    invite_mail_signature: string;

    citypicker_label: string;
    citypicker_nomatch: string;

    options_tab_profile: string;

    userprofile_name_label: string;
    userprofile_surname_label: string;
    userprofile_email_label: string;
    userprofile_city_label: string;
    userprofile_locale_label: string;
    userprofile_theme_label: string;
    userprofile_themedark_label: string;
    userprofile_themelight_label: string;
    userprofile_color_label: string;
    userprofile_label_green: string;
    userprofile_label_indigo: string;
    userprofile_label_pink: string;
    userprofile_label_teal: string;
    userprofile_label_yellow: string;
    userprofile_label_orange: string;
    userprofile_label_purple: string;

    consentdialog_button_ok: string;
    consentdialog_button_cancel: string;

    // End Meet
    layout_meet_end: string;
    // Leave Meet
    layout_meet_leave: string;

    // "Open sidebar menu"
    layout_sidebar_labelOpen: string;

    // "Close sidebar menu"
    layout_sidebar_labelClose: string;

    // "Open sidebar menu"
    layout_sidebar_labelTitle: string;

    // Meet | Frictionless interviews
    layout_title_text: string;

    // "Invite"
    layout_toolbar_invite: string;

    // "Invite other people to this Meet"
    layout_toolbar_invite_tooltip: string;

    // "Enter fullscreen"
    layout_toolbar_enter: string;
    // "Leave fullscreen"
    layout_toolbar_leave: string;

    // "Would you want to end this Meet?"
    layout_dialog_titleAbandon: string;

    // "It looks like you are the one one on the call"
    layout_dialog_descriptionAbandon: string;

    // "Are you sure you want to end this Meet?"
    layout_dialog_titleEnd: string;
    // "Are you sure you want to leave this Meet?"
    layout_dialog_titleLeave: string;
    // "This will end Meet for all of the participants"
    layout_dialog_descriptionEnd: string;
    // "This will NOT end Meet for other participants"
    layout_dialog_descriptionLeave: string;
    // Share feedback
    layout_sidebar_feedback: string;
    // Help
    layout_sidebar_explorer: string;

    // Settings
    layout_sidebar_settings: string;



    // "End the current meeting"
    layout_finish_endmeet: string;
    // "Leave the current meeting"
    layout_finish_leavemeet: string;

    // Need a 60 min free Meet?
    layout_cta_register: string;

    // Sign up for a free 10$ credit
    layout_cta_register_tooltip: string;

    // English
    language_en_title: string;
    // Srpski
    language_srLatn_title: string;
    // Српски
    language_srCyrl_title: string;
    // Français
    language_fr_title: string;
    // Español
    language_es_title: string;
    // Deutsche
    language_de_title: string;
    // Italian
    language_it_title: string;

    // Polski
    language_pl_title: string;

    // Finished meeting
    meeting_finished_title: string;
    // Read-only access
    meeting_finished_tooltip: string;

    // Reactivate Meet
    layout_reactivate_button: string;
    // Click here if you want to reopen and use it already finished Meet.
    layout_reactivate_tooltip: string;
    // "Are you sure you want to reactivate this Meet?"
    layout_dialog_titleReactivate: string;
    // "This will re-open the Meet for joining, editing and other collaboration"
    layout_dialog_descriptionReactivate: string;

    // Calling signaling problem
    toast_reconnecting_title: string;
    // Connection (state:{state}) lost due to error {error}. Reconnecting...
    toast_reconnecting_message: string;
    // Calling signaling
    toast_reconnected_title: string;
    // Connection reestablished. State: {state}
    toast_reconnected_message: string;
    // Calling signaling error
    toast_disconnected_title: string;
    // Connection (state: {state}) closed due to error {error}. Try refreshing this page to restart the connection.
    toast_disconnected_message: string;

     // Create new Meet
     config_title_text: string;
     // Please define the elements of a new Meet you want to create.
     config_title_ctaOne: string;
     // All of the input data is optional and can be omitted.
     config_title_ctaTwo: string;
     // Title
     config_title_label: string;
     // Description
     config_description_label: string;
     // Duration
     config_duration_label: string;
     // Meet tools
     config_tool_label: string;
     // Meet call
     config_tool_call: string;
     // Code editor
     config_tool_editor: string;
     // Whiteboard
     config_tool_whiteboard: string;
     // Meet passcode (if any)
     config_passcode_label: string;

     // Enter search criteria
     search_placeholder_text: string;
     // Create Meet
     createMeeting_button_create: string;

    // Meeting has no start date defined so it can be used anytime
    projectboard_scheduleinfo_none: string;
    // anytime
    projectboard_scheduleinfo_anytime: string;

    // Anyone with a link can join
    projectboard_join_anyone: string;
    // "Guest"
    projectboard_role_guest: string;
    // Interviewee
    projectboard_role_interviewee: string;
    // Interviewer
    projectboard_role_interviewer: string;
    // Organizer
    projectboard_role_organizer: string;

    // In draft
    projectboard_status_draft: string;
    // Scheduling
    projectboard_status_scheduling: string;
    // Scheduling failed
    projectboard_status_schedulingFailed: string;
    // Pending
    projectboard_status_pending: string;
    // Ready
    projectboard_status_ready: string;
    // Starting
    projectboard_status_starting: string;
    // In progress
    projectboard_status_inprogress: string;
    // On hold
    projectboard_status_onhold: string;
    // Completed
    projectboard_status_completed: string;
    // Canceled
    projectboard_status_canceled: string;
    // Archived
    projectboard_status_archived: string;
    // "Waiting for feedback";
    projectboard_status_feedbackWait: string;
    // "Feedback collected";
    projectboard_status_feedbackDone: string;
    // "Feedback collection failed"
    projectboard_status_feedbackFail: string;

    // stopped
    projectboard_status_stopped: string;

    // Dashboard
    minibar_dashboard_title: string;

    // Rate us
    layout_sidebar_rateus: string;

    // Passcode
    invite_passcode_label: string;

    // Copy invite
    invite_text_copy: string;

    // Please join my Meet at {url}
    invite_text_body: string;

    // Please join my Meet at {url} and use passcode {passcode} to login.
    invite_passcode_body: string;

    // Meet invite text is copied to clipboard.
    invite_text_copied: string;

    // Add passcode to url
    invite_pascode_add: string;

    // {participant} had joined the meeting.`
    participant_join_message: string;

    // {participant} had left the meeting.
    participant_left_message: string;

    // Manage your interviews
    minibar_dashboard_tooltip: string;

    // Snapshot
    layout_sidebar_snapshot: string;

    // There are no saved snapshots.
    snapshots_none_text: string;
    // Snapshot taken
    snapshot_toast_text: string;

    // Take snapshot (F9)
    snapshots_cta_text: string;

    // Go back to live Meet
    snapshots_live_text: string;

    // Positive snapshot
    snapshot_sentiment_positive: string;
    // Negative snapshot
    snapshot_sentiment_negative: string;
    // Note
    snapshot_sentiment_note: string;

    // Visible only to you
    snapshot_personal_title: string;
    // Personal snapshot
    snapshot_personal_value: string;
    // Visible only to your team.
    snapshot_team_title: string;
    // Team snapshot
    snapshot_team_value: string;
    // Visible to all participants
    snapshot_public_title: string;
    // Public snapshot
    snapshot_public_value: string;

    // Delete
    snapshot_action_delete: string;
    // Load snapshot
    snapshot_action_load: string;

    // Delete snapshot?
    snapshot_delete_dialog_title: string;
    // Please confirm that you want to delete this snapshot
    snapshot_delete_dialog_description: string;

    // Go back to Meet end state
    snapshots_final_back: string;
}

i18next
    .use(LanguageDetector)
    .init({
        debug: false,
        detection: {
            caches: ["localStorage", "cookie"],
            lookupCookie: "meet-i18n",
            lookupLocalStorage: "meet-i18n",
        },
        fallbackLng: "en",
        interpolation: {
            // React already does escaping
            escapeValue: false,
        },
        resources: {
            "de": {
                translation: translation_de,
            },
            "en": {
                translation: translation_en,
            },
            "es": {
                translation: translation_es,
            },
            "fr": {
                translation: translation_fr,
            },
            "it": {
                translation: translation_it,
            },
            "pl": {
                translation: translation_pl,
            },
            "sr-cyrl": {
                translation: translation_sr_cyrl,
            },
            "sr-Cyrl": {
                translation: translation_sr_cyrl,
            },
            "sr-latn": {
                translation: translation_sr_latn,
            },
            "sr-Latn": {
                translation: translation_sr_latn,
            },
        },

        nonExplicitWhitelist: true,

    });

export default i18next;
